import React from "react";
import { cn } from "@/lib/utils";

// A simplified version of the ui/Chart ChartTooltipContent that can be used outside of a recharts chart
export function ChartTooltipContent({
  className,
  title,
  children,
}: {
  active?: boolean;
  className?: string;
  title: string;
  children?: React.ReactNode;
}) {
  return (
    <div
      className={cn(
        "grid w-[50px] min-w-[8rem] items-start gap-1.5 rounded-lg border border-border/50 bg-background px-2.5 py-1.5 text-xs shadow-xl",
        className,
      )}
    >
      <div className="font-medium">{title}</div>
      <div className="grid gap-1.5">{children}</div>
    </div>
  );
}

/* Display line showing one data point on graph */
export const TooltipLineItem = ({
  label,
  value,
  color,
}: {
  label: string;
  value: number;
  color: string;
}) => {
  const style = {
    "--color-bg": color,
    "--color-border": color,
  } as React.CSSProperties;
  return (
    <div className="[&amp;&gt;svg]:h-2.5 [&amp;&gt;svg]:w-2.5 [&amp;&gt;svg]:text-muted-foreground flex w-full flex-wrap items-center gap-2">
      <div
        className={`h-2.5 w-2.5 shrink-0 rounded-[2px] border-(--color-border) bg-(--color-bg)`}
        style={style}
      ></div>
      <div className="flex flex-1 items-center justify-between leading-none">
        <div className="grid gap-1.5">
          <span className="text-muted-foreground">{label}</span>
        </div>
        <span className="font-mono font-medium text-foreground tabular-nums">
          {value}
        </span>
      </div>
    </div>
  );
};
